import React from "react";

export function AmpRelatedArticles(props: any) {
  const { title, articles } = props;
  return (
    <div className="related-articles">
      <h2 className="related-articles__title">{title}</h2>
      <div className="related-articles__list">{articles}</div>
    </div>
  );
}

export default AmpRelatedArticles;
